import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";

import { useGetFormList } from "../../../lib/queries/queriesAndMutations";
import Loader from "../../shared/Loader";
import Pagination from "../../shared/Pagination";
import Hint from "../Hint";
import PaymentLinkCard from "./PaymentLinkCard";

const PaymentLinkList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const type = useSelector((store) => store.bussinessSlice.type);
  const businessId = useSelector((store) => store.bussinessSlice?.data?.business?.id);

  const onPageChange = useCallback((page) => setCurrentPage(page), []);

  const {
    data: formList,
    isPending,
    refetch,
  } = useGetFormList({
    type,
    businessId,
    currentPage,
    pageSize,
  });

  if (isPending) {
    return (
      <div className="w-full h-full flex-center min-h-[400px] ">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {formList?.data.count > 0 ? (
        <div className="w-full p-2">
          <div className="w-full flex flex-col items-end bg-neutral-00 md:p-6 rounded-v-lg gap-4">
            {/* <div className="w-full flex justify-between items-center">
              <div onClick={handleNewAccount}>
                <Buttons
                  btnStyleparam={"mainbutton"}
                  fontsize={"dashboard"}
                  bgcolor={"primary"}
                  txtcolor={"primary"}
                  children={"فرم جدید"}
                  lefticon={false}
                  righticon={false}
                  borders={"secondary"}
                  bRadius={"xl"}
                />
              </div>
            </div> */}

            <div className="w-full md:bg-neutral-10 grid grid-cols-1  lg:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-4 gap-2 md:gap-4 p-2 md:p-4 rounded-[16px]  ">
              {formList?.data.count > 0 ? (
                formList?.data.items.map((item, index) => (
                  <PaymentLinkCard
                    key={index}
                    rowData={item}
                    index={index}
                    refetch={refetch} // Pass the refetch function
                  />
                ))
              ) : (
                <p>آیتمی وجود ندارد ...</p>
              )}
            </div>
          </div>

          <div className="w-full bg-neutral-10 rounded-v-lg mt-2">
            <Pagination
              onPageChange={onPageChange}
              totalCount={formList?.data?.count || 0}
              siblingCount={1}
              currentPage={currentPage}
              pageSize={pageSize}
              className="bg-primary-40"
            />
          </div>
        </div>
      ) : (
        <div className="w-full h-full flex justify-center items-center ">
          <div className="flex flex-col  gap-6 p-6 bg-white max-w-[700px]   rounded-xl shadow-md w-fit">
            <Hint
              hintStyle="entry"
              response="mobile"
              hintImage={true}
              title="به بخش فرم ها خوش آمدید!"
              entry="flex justify-center items-center"
            >
              <p className="flex justify-center items-center mb-4">
                هنوز فرم پرداختی برای شما ایجاد نشده است.
              </p>
            </Hint>
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentLinkList;
